module.exports = __webpack_public_path__ + "static/img/1_1_4_2.e81d6df9.jpg";